import Phaser from 'phaser';
import { getAudio } from '../audio';
import type { Manifest } from '../assets';

export class HubScene extends Phaser.Scene {
  constructor() { super('Hub'); }
  create(): void {
    this.cameras.main.setBackgroundColor('#0d0a12');
    const audio = getAudio();
    audio?.load((this.registry.get('manifest') as Manifest | undefined)?.audio);
    audio?.music('hub');
  }
}
